import React, { useEffect, useMemo } from 'react'
import { Grid, Typography, Button } from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { useGlobalState } from '../provider/Provider'
import { getUncontract, putUncontract, typeputUncontract } from '../api/helpline/mikeiyaku'
import UncontractEditForm from '../component/portal/uncontractedit/UncontractEditForm'
import NotFound from './NotFound'

interface Prop {
  handleError: (err: any) => void,
  handleNotificationOpen: (level: "success" | "info" | "warning" | "error", message: string) => void,
}

const ROOTPATH = process.env.REACT_APP_ROOT_PATH!

const UncontractEdit: React.FC<Prop> = (props) => {
  const globalState = useGlobalState('user')
  const { userId, token, role } = globalState
  const { handleError, handleNotificationOpen } = props
  const history = useHistory()
  //@ts-ignore
  const { usercd } = useParams()
  const decode_usercd = useMemo(() => {
    try {
      if (usercd) {
        return atob(usercd)
      } else {
        return ''
      }
    } catch {
      return usercd
    }
  }, usercd)
  const [loading, setLoading] = React.useState<boolean>(false)
  const [rescheck, setRescheck] = React.useState<boolean>(true)//response204チェック
  const [form, setForm] = React.useState<typeputUncontract>({
    userName: '',
    userNameSyllabary: '',
  })
  const [reqItem, setReqItem] = React.useState({
    userName: true,
    userNameSyllabary: true,
  })

  const handleBackPage = () => {
    history.push(`${ROOTPATH}/uncontractcr`)
  }

  //文字数カット
  const MAX_LENGTH = 128
  const checkCutLength = (str: string, name: string): string => {
    let cutStr = str
    switch (name) {
      case 'userName':
      case 'userNameSyllabary':
        if (str.length > MAX_LENGTH) {
          cutStr = str.substr(0, MAX_LENGTH)
        }
        break
    }
    return cutStr
  }

  const handleChangeForm = (event: React.ChangeEvent<{ value: unknown; name?: string | undefined }>) => {
    setForm({
      ...form,
      [event.target.name as string]: checkCutLength(event.target.value as string, event.target.name as string)
    })
  }

  const SyllabaryCheck = (str: string) => {
    if (str.length !== 1) {
      return true
    } else if (str.match(/^[ァ-ヶー　]+$/)) {//全角カタカナの1文字のみ
      return false;
    } else {
      return true;
    }
  }

  const onSubmit = () => {
    setLoading(true)
    putUncontract(userId, token, role, decode_usercd, form).then(res => {
      if (res) {
        handleNotificationOpen('success', '未契約顧客の編集')
        handleBackPage()
      }
      setLoading(false)
    }).catch(err => { setLoading(false); handleError(err) })
  }

  //初期表示APIコール
  useEffect(() => {
    //メンバー情報一覧取得
    if (userId && token && role && decode_usercd) {
      getUncontract(userId, token, role, decode_usercd).then(res => {
        if (res) {
          setForm({
            ...form,
            userName: res.userName,
            userNameSyllabary: res.userNameSyllabary,
          })
        } else {
          setRescheck(false)
        }
      }).catch(err => handleError(err))
    }
  }, [])

  //必須項目チェックState更新
  useEffect(() => {
    setReqItem({
      ...reqItem,
      userName: form.userName ? false : true,
      userNameSyllabary: form.userNameSyllabary ? SyllabaryCheck(form.userNameSyllabary) : true,
    })
  }, [form.userName, form.userNameSyllabary])


  return (
    <React.Fragment>
      <Grid container direction="row" justify="flex-start">
        <Typography variant="h6" style={{ flexGrow: 1 }}>
          未契約顧客編集
      </Typography>
        <Button variant="outlined"
          color="primary" size="small"
          onClick={handleBackPage}>戻る</Button>
      </Grid>
      {rescheck ?
        <UncontractEditForm handleChangeForm={handleChangeForm} form={form} loading={loading} onSubmit={onSubmit} reqItem={reqItem} />
        : <NotFound />}
    </React.Fragment>
  )
}

export default UncontractEdit
